import { StackDivider, VStack } from "@chakra-ui/react"
import File from "./File";

const Files = () => {
    return (
        <VStack mt="8" spacing="6" w="full" divider={<StackDivider w="full" />}>
            <File />
            <File />
            <File />
            <File />
        </VStack>
    )
}

export default Files
